import { render } from "./hris-toggle.vue?vue&type=template&id=44b9174d&lang=pug"
import script from "./hris-toggle.vue?vue&type=script&lang=js"
export * from "./hris-toggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__